// extracted by mini-css-extract-plugin
export var github = "github-module--github--ba5f4";
export var github__arm = "github-module--github__arm--2213b";
export var octocatWave = "github-module--octocat-wave--4925c";